import { sendCursorAgentMessage } from './cursorAgentClient';
import type { CursorAgentProgress } from './cursorAgentApi';

/** One-shot coach question via Cursor Cloud Agents (new agent per request). */
export async function askChessCoach(
  prompt: string,
  onStatus?: (status: string) => void
): Promise<string> {
  const result = await sendCursorAgentMessage(prompt, null, (progress: CursorAgentProgress) => {
    if (progress.phase === 'create') onStatus?.('Starting coach analysis…');
    else if (progress.phase === 'poll') {
      const st = progress.status ?? 'running';
      onStatus?.(`Coach working (${st})…`);
    } else if (progress.phase === 'fetch-agent') onStatus?.('Fetching response…');
  });
  return result.reply.trim();
}
